import React, { useState, useImperativeHandle, forwardRef } from "react";
import "./BitcoinAnimation.css";

const BitcoinAnimation = forwardRef(({ index }, ref) => {
  const [score, setScore] = useState(0);
  const [coins, setCoins] = useState([]);

  useImperativeHandle(ref, () => ({
    addCoin(index) {
      const coinKey = Date.now().toString();
      setCoins((prev) => [...prev, { key: coinKey, index }]);
      setScore((prev) => prev + 1);
    },
  }));

  return (
    <div className="coin-game-container">
      <div className="coins-container">
        {coins.map((coinObj) => {
          const { key, index } = coinObj;
          const imageIndex = index || 1;

          return (
            <div
              key={key}
              className="coin-animation"
              onAnimationEnd={() =>
                setCoins((prev) => prev.filter((c) => c.key !== key))
              }
            >
              <img
                src={require(`../../assets/images/coins/${imageIndex}.png`)}
                alt={`${imageIndex} coin`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default BitcoinAnimation;
